import type { ThemeState } from './types.js';
import { DEFAULT_THEME_STATE } from './types.js';

export type StorageMode = 'localStorage' | 'session' | 'memory';

const memoryStore: Record<string, string> = {};

export function readState(mode: StorageMode, key: string): Partial<ThemeState> {
  try {
    let raw: string | null = null;
    if (mode === 'localStorage' && typeof window !== 'undefined') {
      raw = window.localStorage.getItem(key);
    } else if (mode === 'session' && typeof window !== 'undefined') {
      raw = window.sessionStorage.getItem(key);
    } else {
      raw = memoryStore[key] ?? null;
    }
    if (raw === null || raw === '') return {};
    const parsed: unknown = JSON.parse(raw);
    if (parsed === null || typeof parsed !== 'object') return {};
    return parsed as Partial<ThemeState>;
  } catch {
    return {};
  }
}

export function writeState(mode: StorageMode, key: string, state: ThemeState): void {
  try {
    const value = JSON.stringify(state);
    if (mode === 'localStorage' && typeof window !== 'undefined') {
      window.localStorage.setItem(key, value);
    } else if (mode === 'session' && typeof window !== 'undefined') {
      window.sessionStorage.setItem(key, value);
    } else {
      memoryStore[key] = value;
    }
  } catch {
    // best-effort; ignore quota/security errors
  }
}

export function mergeDefaults(partial: Partial<ThemeState>): ThemeState {
  return { ...DEFAULT_THEME_STATE, ...partial };
}
